import { createFileRoute } from '@tanstack/react-router';

import { ApprovalRulesPage } from '@/features/approvals/rules-page';

/** The person's own approval rules as an individual owner (`/me/approval-rules`). */
export const Route = createFileRoute('/_app/account/approval-rules')({
  component: PersonalApprovalRules,
});

function PersonalApprovalRules() {
  return <ApprovalRulesPage orgId={null} />;
}
